import { Checkbox } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

import './DuplicatePermissionCheckbox.scss';

/**
 * TAK-2080: the "Can duplicate this activity" box shown after the page
 * permissions when inviting a member or editing their permissions. Greyed out
 * (and off) for presets that can't duplicate.
 */
const DuplicatePermissionCheckbox = ({ checked, disabled, onChange }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`duplicate-permission${
        disabled ? ' duplicate-permission--disabled' : ''
      }`}
    >
      <Checkbox
        label={t('activity.activity_plan.duplicate_permission')}
        checked={Boolean(checked) && !disabled}
        disabled={disabled}
        onChange={(e, data) => onChange(Boolean(data.checked))}
      />
      <p className="duplicate-permission__hint">
        {disabled
          ? t('activity.activity_plan.duplicate_permission_locked')
          : t('activity.activity_plan.duplicate_permission_hint')}
      </p>
    </div>
  );
};

export default DuplicatePermissionCheckbox;
